import { Languages } from '@/core/typing'

interface IFaQItem {
    id: string
    question: string
    answer: string
}

export const translateFAQEN: IFaQItem[] = [
    {
        id: '1',
        question: 'What is SafeTravy?',
        answer: ' SafeTravy is a free all-in-one travel guidance platform designed to support travelers. It provides up-to-date information on climate, social, and medical situations worldwide, as well as visa and entry requirements. Additionally, SafeTravy offers personalized AI assistance tailored to your travel needs.',
    },
    {
        id: '2',
        question: 'Is SafeTravy free to use?',
        answer: 'Yes, SafeTravy is completely free to use. You can access and enjoy all of its features without any cost or subscription required.',
    },
    {
        id: '3',
        question: 'How often is information updated on the platform?',
        answer: 'Country-specific information is updated monthly, while weather conditions are delivered in real time.',
    },
    {
        id: '4',
        question: 'What do the different colors on the map mean?',
        answer: 'The colors reflect the level of risk. Red indicates a high risk, yellow indicates moderate risk, green means safe, and gray means no data is available.',
    },
    {
        id: '5',
        question:
            'How can I find out visa requirements and allowed stay duration to the destination country?',
        answer: 'Simply go to the “Entry Requirements” section, select your departure and destination countries, and click “Search.” You’ll see all the necessary details, including visa requirements and permitted stay durations.',
    },
    {
        id: '6',
        question:
            'How does the travel insurance promo code for SafeTravy subscribers work?',
        answer: 'As a SafeTravy registered user, you receive a promo code for $9 off Auras travel insurance. This discount covers up to 6 days of worldwide protection for your next trip. If your trip is longer or includes extreme activities, the discount still applies. Auras travel insurance includes: Worldwide Coverage: Valid in any country. Visa and Embassy Approval: Meets visa and embassy requirements. Suitable for All Ages: Covers travelers aged 1 to 100. 24/7 Support: Multilingual assistance anytime, anywhere. To use your promo code, simply apply it during your insurance purchase. It’s easy and ensures you’re protected for every journey! Where to find your promo code: Your promo code will be sent to you via email. If you can’t find it in your inbox, don’t forget to check your Promotions or Ads folder — it might be waiting for you there!',
    },
    {
        id: '7',
        question: 'How do I use the chatbot?',
        answer: 'You can interact with Travy, our AI assistant, to get answers to your travel-related questions. For a more personalized experience, complete a quick survey when using Travy to tailor responses and recommendations to your specific needs.',
    },
]

export const translatesFAQDE: IFaQItem[] = [
    {
        id: '1',
        question: 'Was ist SafeTravy?',
        answer: 'SafeTravy ist eine kostenlose All-in-One-Reiseplattform zur Unterstützung von Reisenden. Sie bietet aktuelle Informationen zu Klima, sozialen und medizinischen Situationen weltweit sowie zu Visa- und Einreisebestimmungen. Darüber hinaus bietet SafeTravy eine personalisierte KI-gestützte Unterstützung, die auf deine Reisebedürfnisse zugeschnitten ist.',
    },
    {
        id: '2',
        question: 'Ist SafeTravy kostenlos?',
        answer: 'Ja, SafeTravy ist völlig kostenlos. Du kannst alle Funktionen ohne Kosten oder Abonnement nutzen.',
    },
    {
        id: '3',
        question:
            'Wie oft werden die Informationen auf der Plattform aktualisiert?',
        answer: 'Länderspezifische Informationen werden monatlich aktualisiert, während Wetterbedingungen in Echtzeit bereitgestellt werden.',
    },
    {
        id: '4',
        question: 'Was bedeuten die verschiedenen Farben auf der Karte?',
        answer: 'Die Farben zeigen das Risikoniveau an. Rot steht für hohes Risiko, Gelb für mittleres Risiko, Grün bedeutet sicher, und Grau bedeutet, dass keine Daten verfügbar sind.',
    },
    {
        id: '5',
        question:
            'Wie kann ich die Visabestimmungen und die erlaubte Aufenthaltsdauer für mein Reiseziel herausfinden?',
        answer: 'Gehe einfach zum Abschnitt „Einreisebestimmungen“, wähle dein Abreise- und Zielland aus und klicke auf „Suchen“. Du erhältst alle wichtigen Details, einschließlich Visabestimmungen und erlaubter Aufenthaltsdauer.',
    },
    {
        id: '6',
        question:
            'Wie funktioniert der Reiseversicherungs-Gutscheincode für SafeTravy-Abonnenten?',
        answer: 'Als registrierter SafeTravy-Nutzer erhältst du einen Gutscheincode für 9 $ Rabatt auf die Auras-Reiseversicherung. Dieser Rabatt deckt bis zu 6 Tage weltweiten Schutz für deine nächste Reise ab. Falls deine Reise länger dauert oder extreme Aktivitäten umfasst, gilt der Rabatt trotzdem. Die Auras-Reiseversicherung umfasst: Weltweite Abdeckung: Gültig in jedem Land. Visa- und Botschaftsgenehmigung: Erfüllt die Anforderungen für Visa und Botschaften. Für alle Altersgruppen geeignet: Deckt Reisende von 1 bis 100 Jahren ab. 24/7 Unterstützung: Mehrsprachiger Support jederzeit und überall. Um deinen Gutscheincode zu nutzen, gib ihn einfach beim Kauf deiner Versicherung ein. Es ist einfach und sorgt für deine Sicherheit auf jeder Reise! Wo finde ich meinen Gutscheincode? Dein Gutscheincode wird dir per E-Mail zugesendet. Falls du ihn nicht im Posteingang findest, überprüfe bitte deinen Ordner für Werbung oder Promotionen – vielleicht wartet er dort auf dich!',
    },
    {
        id: '7',
        question: 'Wie benutze ich den Chatbot?',
        answer: 'Du kannst mit Travy, unserem KI-Assistenten, interagieren, um Antworten auf deine reisebezogenen Fragen zu erhalten. Für eine noch individuellere Erfahrung kannst du eine kurze Umfrage ausfüllen, während du Travy nutzt, damit die Antworten und Empfehlungen besser auf deine speziellen Bedürfnisse abgestimmt sind.',
    },
]

export const translatesFAQES: IFaQItem[] = [
    {
        id: '1',
        question: '¿Qué es SafeTravy?',
        answer: 'SafeTravy es una plataforma gratuita y todo en uno de orientación para viajeros. Proporciona información actualizada sobre el clima, la situación social y médica en todo el mundo, así como los requisitos de visa y entrada. Además, SafeTravy ofrece asistencia personalizada con IA adaptada a tus necesidades de viaje.',
    },
    {
        id: '2',
        question: '¿SafeTravy es gratis?',
        answer: 'Sí, SafeTravy es completamente gratuito. Puedes acceder y disfrutar de todas sus funciones sin ningún costo ni suscripción.',
    },
    {
        id: '3',
        question:
            '¿Con qué frecuencia se actualiza la información en la plataforma?',
        answer: 'La información específica de cada país se actualiza mensualmente, mientras que las condiciones climáticas se ofrecen en tiempo real.',
    },
    {
        id: '4',
        question: '¿Qué significan los diferentes colores en el mapa?',
        answer: 'Los colores reflejan el nivel de riesgo. Rojo indica alto riesgo, amarillo indica riesgo moderado, verde significa seguro y gris indica que no hay datos disponibles.',
    },
    {
        id: '5',
        question:
            '¿Cómo puedo saber los requisitos de visa y la duración permitida de estancia en el país de destino?',
        answer: 'Simplemente ve a la sección “Requisitos de Entrada”, selecciona tu país de origen y destino, y haz clic en “Buscar”. Verás todos los detalles necesarios, incluyendo los requisitos de visa y la duración de la estancia permitida',
    },
    {
        id: '6',
        question:
            '¿Cómo funciona el código promocional de seguro de viaje para los suscriptores de SafeTravy?',
        answer: 'Como usuario registrado de SafeTravy, recibirás un código promocional de $9 de descuento en el seguro de viaje de Auras. Este descuento cubre hasta 6 días de protección mundial para tu próximo viaje. Si tu viaje es más largo o incluye actividades extremas, el descuento aún se aplica. El seguro de viaje de Auras incluye: Cobertura mundial: Válido en cualquier país. Aprobación para visa y embajadas: Cumple con los requisitos de visa y embajada. Apto para todas las edades: Cubre viajeros de 1 a 100 años. Asistencia 24/7: Soporte multilingüe en cualquier momento y lugar. Para usar tu código promocional, simplemente aplícalo al comprar tu seguro. ¡Es fácil y garantiza tu protección en cada viaje! ¿Dónde encontrar tu código promocional? Tu código promocional se enviará por correo electrónico. Si no lo encuentras en tu bandeja de entrada, revisa la carpeta de Promociones o Publicidad, ¡puede estar allí esperando por ti!',
    },
    {
        id: '7',
        question: '¿Cómo uso el chatbot?',
        answer: 'Puedes interactuar con Travy, nuestro asistente de IA, para obtener respuestas a tus preguntas relacionadas con viajes. Para una experiencia más personalizada, completa una breve encuesta al usar Travy para adaptar las respuestas y recomendaciones a tus necesidades específicas.',
    },
]

export const translatesFAQFR: IFaQItem[] = [
    {
        id: '1',
        question: "Qu'est-ce que SafeTravy?",
        answer: 'SafeTravy est une plateforme gratuite tout-en-un d’assistance aux voyageurs. Elle fournit des informations à jour sur le climat, la situation sociale et médicale dans le monde entier, ainsi que sur les exigences en matière de visa et d’entrée. De plus, SafeTravy offre une assistance personnalisée grâce à l’IA, adaptée à vos besoins de voyage.',
    },
    {
        id: '2',
        question: "L'utilisation de SafeTravy est-elle gratuite?",
        answer: 'Oui, SafeTravy est entièrement gratuit. Vous pouvez accéder à toutes ses fonctionnalités sans aucun coût ni abonnement.',
    },
    {
        id: '3',
        question:
            'À quelle fréquence les informations sont-elles mises à jour sur la plateforme?',
        answer: 'Les informations spécifiques à chaque pays sont mises à jour chaque mois, tandis que les conditions météorologiques sont fournies en temps réel.',
    },
    {
        id: '4',
        question: 'Que signifient les différentes couleurs sur la carte?',
        answer: ' Les couleurs indiquent le niveau de risque. Rouge signifie un risque élevé, jaune signifie un risque modéré, vert signifie sûr et gris indique qu’aucune donnée n’est disponible.',
    },
    {
        id: '5',
        question:
            'Comment puis-je connaître les exigences de visa et la durée de séjour autorisée dans le pays de destination ?',
        answer: 'Rendez-vous simplement dans la section « Exigences d’entrée », sélectionnez votre pays de départ et votre pays de destination, puis cliquez sur « Rechercher ». Vous verrez tous les détails nécessaires, y compris les exigences de visa et la durée de séjour autorisée.',
    },
    {
        id: '6',
        question:
            'Comment fonctionne le code promo d’assurance voyage pour les abonnés de SafeTravy?',
        answer: 'En tant qu’utilisateur enregistré de SafeTravy, vous recevez un code promo de 9 $ de réduction sur l’assurance voyage Auras. Cette réduction couvre jusqu’à 6 jours de protection mondiale pour votre prochain voyage. Si votre voyage est plus long ou inclut des activités extrêmes, la réduction s’applique toujours. L’assurance voyage Auras comprend: Couverture mondiale : Valable dans n’importe quel pays. Approbation pour visa et ambassades : Conforme aux exigences des visas et des ambassades. Adaptée à tous les âges : Couvre les voyageurs de 1 à 100 ans. Assistance 24/7 : Support multilingue à tout moment, n’importe où. Pour utiliser votre code promo, appliquez-le simplement lors de l’achat de votre assurance. C’est simple et cela garantit votre protection à chaque voyage! Où trouver votre code promo? Votre code promo vous sera envoyé par e-mail. Si vous ne le trouvez pas dans votre boîte de réception, pensez à vérifier votre dossier Promotions ou Publicités — il pourrait vous y attendre!',
    },
    {
        id: '7',
        question: 'Comment utiliser le chatbot?',
        answer: 'Vous pouvez interagir avec Travy, notre assistant IA, pour obtenir des réponses à vos questions sur le voyage. Pour une expérience plus personnalisée, remplissez un court questionnaire lors de l’utilisation de Travy afin d’adapter les réponses et recommandations à vos besoins spécifiques.',
    },
]

export const transaltesFAQSConfig = {
    [Languages.EN]: translateFAQEN,
    [Languages.DE]: translatesFAQDE,
    [Languages.ES]: translatesFAQES,
    [Languages.FR]: translatesFAQFR,
}
